module.exports = __webpack_public_path__ + "img/gdp-blue-logo.36ba9026.svg";